import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateGlobalExclusionsApp = document.createElement('template');

templateGlobalExclusionsApp.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
   ${/* TBD: push-body component */ ''}
  <gz-push-body-layout resizable="right">
     <div slot="push-body-sidenav-title">
        <gz-title id="listTitle" class="title" fontSize="11" fontweight="600"></gz-title>
    </div>
     <div slot="push-body-sidenav">
        <gz-exclusion-lists></gz-exclusion-lists>
    </div>
     <div slot="push-body-content" class="content">
           <gz-global-exclusions></gz-global-exclusions>
     </div>
  </gz-push-body-layout>
  <gz-new-exclusion-list class="new-exclusion-list"></gz-new-exclusion-list>
`;
